import * as React from 'react';

const SvgIconAnniversary = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 35 37" width={36} height={36} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M17.453 22.5l-9-7.875 4.162-5.202c.215-.269.54-.425.885-.423h7.919c.341 0 .665.156.878.423l4.155 5.202-9 7.875z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.453 4.5V1.125M28.59 9.113l2.387-2.387M6.316 9.113L3.93 6.726M8.453 14.625h18M17.453 9v13.5M3 34.875a14.628 14.628 0 0128.907 0M8.736 34.875a9 9 0 0117.433 0"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconAnniversary;
